export let basicTextGroupOverflowMenuLabel = "L$nwF";
export default {basicTextGroupOverflowMenuLabel};